"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require("../styles/Item.css");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
* Nom : ItemKpi.js
* Description : Ce fichier contient la définition du composant ItemKpi
*               Ce composant est un cadre pour afficher un KPI
* Date de création : 7 juillet 2026
*/

/* CSS et assets */

/* Bibliothèques et composants */

/* Hook */
// None

/**
* ItemKpi : ce composant est un cadre pour afficher un KPI
*
* Type : composant 
*
* Parametres : 
*  - children -- contenu de l'élément à afficher
*/function ItemKpi(_ref) {
  var title = _ref.title,
    children = _ref.children;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "item-kpi-border",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "item-kpi-title",
      children: title
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "item-kpi-data",
      children: children
    })]
  });
}

// Les propTypes permettent de sécuriser les données en specifiant le type de donnée attendu pour une prop
ItemKpi.propTypes = {
  title: _propTypes["default"].string
};
var _default = exports["default"] = ItemKpi;